import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../contexts/AppContext';
import PurchaseOrderExclusionCertificatesAPI from '../../services/PurchaseOrderExclusionCertificatesAPI';

export const SORT = {
  UPWARD: 'upward',
  DOWNWARD: 'downward',
  NONE: '',
};

const useExcludedCertificatePurchaseOrdersPresenter = tableRef => {
 
  const { showError, showWarning } = useContext(AppContext);
  const [firstLoad, setFirstLoad] = useState(true);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [rowsToShow, setRowsToShow] = useState([]);
  const [oldSearchRequest, setOldSearchRequest] = useState({});
  const [open, setOpen] = useState(false);

  const [purchaseOrderCode, setPurchaseOrderCode] = useState('');
  const [openExclusion, setOpenExclusion] = useState(false);

  const [openActivity, setOpenActivity] = useState(false);

  useEffect(() => {
    search();
  }, []);

  useEffect(() => {
    !openExclusion && !firstLoad && reloadGrid(true);
  }, [openExclusion])

  useEffect(() => {
    setRowsToShow(rows);
  }, [rows]);

  const cleanFilters = () => {

    setPurchaseOrderCode('');
  };

  const search = reload => {

    const request = reload ? oldSearchRequest : { PurchaseOrderCode: purchaseOrderCode};
    setOldSearchRequest(request);

    firstLoad && setFirstLoad(false);
    setLoading(true);
    //setSelectedRows([]);

    PurchaseOrderExclusionCertificatesAPI.getDataGrid(request)
      .then(res => {
        setRows(res.data)
      })
      .catch(error => showError('Error al obtener los registros'))
      .finally(() => setLoading(false));
  };

  const reloadGrid = () => search(true);


  const validateAndSearch = () => search()//validateFilters() && search();


  return {

    purchaseOrderCode,
    setPurchaseOrderCode,
    openExclusion,
    setOpenExclusion,

    validateAndSearch,
    cleanFilters,
    rows,
    firstLoad,
    loading,
    gridFunctions: {
      disableSelectAll: 
      reloadGrid,
      open,
      setOpen,

      openExclusion,
      setOpenExclusion,

      openActivity, 
      setOpenActivity,

      cuit: oldSearchRequest.cuit,
      gridActions: {
     
      },
    },
  };
};

export default useExcludedCertificatePurchaseOrdersPresenter;